import { NgModule } from '@angular/core';
import { NumberSuffixPipe } from './numberFormat.pipe';
import { UtcToLocalTimePipe } from './utc-local-time.pipe';

@NgModule({
    declarations: [
        NumberSuffixPipe,
        UtcToLocalTimePipe
    ],
    imports: [

    ],
    exports: [
        NumberSuffixPipe,
        UtcToLocalTimePipe
    ]
    
})
export class PipesModule {}